<div class="error-notification-modal">
  <div class="modal-dialog"
       role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{title}}</h5>
        <button type="button"
                class="btn-close"
                aria-label="Close"
                (click)="close()"></button>
      </div>
      <div class="modal-body">
        <strong [innerHTML]="message"></strong><br><br>
        <strong>{{'loginPage.no_order_body2' | translate}}</strong><br><br>
        <div class="contact-details">
          <a href="mailto:{{customerSupportEmail | translate}}">
            {{customerSupportEmail | translate}}
          </a>
        </div>
        <br><br>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn fs-14 m-r-a m-l-0" (click)="close()">Close</button>
      </div>
    </div>
  </div>
</div>
